<template>
    <div v-if="company" class="animated fadeIn">
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Диагностика компании </strong>&laquo;<small>{{company.name}}</small>&raquo;<directory slug="stranica-diagnostiki" />
                    </div>
                    <b-row>
                      <b-col md="4">
                        <b-card class="card-fixed-height">
                          <div slot="header">
                            <strong>Документы</strong> <directory slug="dokumenty" />
                            <c-switch v-b-tooltip.hover title="Разрешить дополнительные документы" class="pull-right" color="primary" v-model="company.enroll.is_add_doc" label outline="alt" variant="pill" v-bind="labelTxt" />
                          </div>
                          <ul class="list-group">
                            <li v-if="company.enroll.contract" class="list-group-item py-2">
                              <b-button size="sm" class="pull-right" @click="confirmUpdate({contract: null})" variant="danger"><i class="fa fa-trash"></i></b-button>
                              <a :href="company.enroll.contract.file">
                                <i class="fa fa-download"></i>
                                Заявка
                              </a>
                            </li>
                            <li v-if="company.enroll.order" class="list-group-item py-2">
                              <b-button size="sm" @click="confirmUpdate({order: null})" class="pull-right" variant="danger"><i class="fa fa-trash"></i></b-button>
                              <a :href="company.enroll.order.file">
                                <i class="fa fa-download"></i>
                                Копия соглашения
                              </a>
                            </li>
                            <li v-if="company.enroll.add_doc" class="list-group-item py-2">
                              <b-button v-if="user" size="sm" @click="confirmUpdate({addDoc: null})" class="pull-right" variant="danger"><i class="fa fa-trash"></i></b-button>
                              <a :href="company.enroll.add_doc.file">
                                <i class="fa fa-download"></i>
                                Доп. документы
                              </a>
                            </li>
                            <li v-if="!company.enroll.contract && !company.enroll.add_doc" class="list-group-item py-2 disabled">
                              Этап в данный момент недоступен
                            </li>
                          </ul>
                        </b-card>
                      </b-col>
                      <b-col md="4">
                        <b-card class="card-fixed-height">
                          <div slot="header">
                            <strong>Экспресс-оценка финансового состояния</strong>
                          </div>
                          <ul class="list-group">
                            <li v-if="!company.enroll.reports.finance_express_report" class="list-group-item py-2 disabled">
                              Этап в данный момент недоступен
                            </li>
                            <li v-if="company.enroll.reports.finance_express_report" class="list-group-item py-2" :class="'list-group-item-' + company.enroll.reports.finance_express_report.status">
                              {{ company.enroll.reports.finance_express_report.status_crm }}
                            </li>
                          </ul>
                          <div slot="footer">
                            <b-button v-if="user.roles.indexOf('ROLE_SUPER_ADMIN') > -1" class="pull-left" variant="info" size="sm" @click="revertReport(company.enroll.reports.finance_express_report.id)"><i class="fa fa-refresh"></i></b-button>
                            <router-link tag="button" class="btn pull-right btn-success btn-sm" :disabled="!company.enroll.reports.finance_express_report" :to="'/diagnost/' + id + '/finance'">
                              <i class="fa fa-eye"></i>
                              Перейти к оценке
                            </router-link>
                          </div>
                        </b-card>
                      </b-col>
                      <b-col md="4">
                        <b-card class="card-fixed-height">
                          <div slot="header">
                            <strong>Оценка экспортной зрелости</strong><br/>
                          </div>
                          <ul v-if="company.enroll.reports.form_report" class="list-group">
                            <li class="list-group-item py-2" :class="'list-group-item-' + company.enroll.reports.form_report.status">
                              {{ company.enroll.reports.form_report.status_crm }}
                            </li>
                          </ul>
                          <p><span v-if="company.enroll.reports.form_report" :class="'badge badge-' + company.enroll.reports.form_report.status + ' text-white'"></span></p>
                          <h5 v-if="company.enroll.form_result">
                            <span class="badge badge-primary">Балл {{company.enroll.form_result.result.points}}</span>&nbsp;
                            <span class="badge badge-warning text-white">{{company.enroll.form_result.result.category}}</span>
                          </h5>
                          <div slot="footer">
                            <b-button v-if="user.roles.indexOf('ROLE_SUPER_ADMIN') > -1" class="pull-left" variant="info" size="sm" @click="revertReport(company.enroll.reports.form_report.id)"><i class="fa fa-refresh"></i></b-button>
                            <router-link :to="'/diagnost/' + company.id + '/form'" tag="button" :disabled="!company.enroll.form_result" class="pull-right btn btn-success btn-sm">
                              <i class="fa fa-eye"></i>
                              Посмотреть результаты
                            </router-link>
                          </div>
                        </b-card>
                      </b-col>
                      <b-col v-if="company.enroll.program && company.enroll.program.id === 1">
                        <b-card class="card-fixed-height">
                          <div slot="header">
                            <strong>Аудит на предмет стоп-факторов</strong>
                          </div>
                          <ul class="list-group">
                            <li v-if="company.enroll.reports.stop_factors_report" class="list-group-item py-2" :class="'list-group-item-' + company.enroll.reports.stop_factors_report.status">
                              {{ company.enroll.reports.stop_factors_report.status_crm }}
                            </li>
                            <li v-if="!company.enroll.reports.stop_factors_report" class="list-group-item py-2 disabled">
                              Этап в данный момент недоступен
                            </li>
                          </ul>
                          <div slot="footer">
                            <b-button v-if="user.roles.indexOf('ROLE_SUPER_ADMIN') > -1" class="pull-left" variant="info" size="sm" @click="revertReport(company.enroll.reports.stop_factors_report.id)"><i class="fa fa-refresh"></i></b-button>
                            <router-link tag="button" class="btn pull-right btn-success btn-sm" :disabled="!company.enroll.reports.stop_factors_report" :to="'/diagnost/' + id + '/factors'">
                              <i class="fa fa-eye"></i>
                              Перейти к аудиту
                            </router-link>
                          </div>
                        </b-card>
                      </b-col>
                      <b-col md="4">
                        <b-card class="card-fixed-height">
                          <div slot="header">
                            <strong>Верификация анкеты экспортной зрелости</strong>&nbsp;
                          </div>
                          <ul class="list-group">
                            <li v-if="!company.enroll.reports.verify_form_report" class="list-group-item py-2 disabled">
                              Этап в данный момент недоступен
                            </li>
                            <li v-if="company.enroll.reports.verify_form_report" class="list-group-item py-2" :class="'list-group-item-' + company.enroll.reports.verify_form_report.status">
                              {{ company.enroll.reports.verify_form_report.status_crm }}
                            </li>
                          </ul>
                          <br/>
                          <h5 v-if="company.enroll.reports.verify_form_report && company.enroll.reports.verify_form_report.report_data">
                            <span class="badge badge-primary">Балл {{company.enroll.reports.verify_form_report.report_data.points}}</span>&nbsp;
                            <span class="badge badge-warning text-white">{{company.enroll.reports.verify_form_report.report_data.category}}</span>
                          </h5>
                          <div slot="footer">
                            <b-button v-if="user.roles.indexOf('ROLE_SUPER_ADMIN') > -1" class="pull-left" variant="info" size="sm" @click="revertReport(company.enroll.reports.verify_form_report.id)"><i class="fa fa-refresh"></i></b-button>
                            <router-link tag="button" class="btn pull-right btn-success btn-sm" :disabled="!company.enroll.reports.verify_form_report" :to="'/diagnost/' + id + '/verify'">
                              <i class="fa fa-eye"></i>
                              Перейти к оценке
                            </router-link>
                          </div>
                        </b-card>
                      </b-col>
                      <b-col md="4">
                        <b-card class="card-fixed-height">
                          <div slot="header">
                            <strong>Структурированное интервью с представителями компании</strong>&nbsp;
                          </div>
                          <ul class="list-group">
                            <li v-if="!company.enroll.reports.interview_report" class="list-group-item py-2 disabled">
                              Этап в данный момент недоступен
                            </li>
                            <li v-if="company.enroll.reports.interview_report" class="list-group-item py-2" :class="'list-group-item-' + company.enroll.reports.interview_report.status">
                              {{ company.enroll.reports.interview_report.status_crm }}
                            </li>
                          </ul>
                          <br/>
                          <h5 v-if="company.enroll.reports.interview_report && company.enroll.reports.interview_report.report_data">
                            <span class="badge badge-primary">Балл {{company.enroll.reports.interview_report.report_data.points}}</span>&nbsp;
                          </h5>
                          <div slot="footer">
                            <b-button v-if="user.roles.indexOf('ROLE_SUPER_ADMIN') > -1" class="pull-left" variant="info" size="sm" @click="revertReport(company.enroll.reports.interview_report.id)"><i class="fa fa-refresh"></i></b-button>
                            <router-link tag="button" class="btn pull-right btn-success btn-sm" :disabled="!company.enroll.reports.interview_report" :to="'/diagnost/' + id + '/interview'">
                              <i class="fa fa-eye"></i>
                              Перейти к оценке
                            </router-link>
                          </div>
                        </b-card>
                      </b-col>
                      <b-col md="4">
                        <b-card class="card-fixed-height">
                          <div slot="header">
                            <strong>Оценка финансового состояния</strong>
                          </div>
                          <ul class="list-group">
                            <li v-if="!company.enroll.reports.finance_report" class="list-group-item py-2 disabled">
                              Этап в данный момент недоступен
                            </li>
                            <li v-if="company.enroll.reports.finance_report" class="list-group-item py-2" :class="'list-group-item-' + company.enroll.reports.finance_report.status">
                              {{ company.enroll.reports.finance_report.status_crm }}
                            </li>
                          </ul>
                          <div slot="footer">
                            <b-button v-if="user.roles.indexOf('ROLE_SUPER_ADMIN') > -1" class="pull-left" variant="info" size="sm" @click="revertReport(company.enroll.reports.finance_report.id)"><i class="fa fa-refresh"></i></b-button>
                            <router-link tag="button" class="btn pull-right btn-success btn-sm" :disabled="!company.enroll.reports.finance_report" :to="'/diagnost/' + id + '/finance-detail'">
                              <i class="fa fa-eye"></i>
                              Перейти к оценке
                            </router-link>
                          </div>
                        </b-card>
                      </b-col>
                      <b-col md="4">
                        <b-card class="card-fixed-height">
                          <div slot="header">
                            <strong>Итоговый отчет</strong>
                          </div>
                          <ul class="list-group">
                            <li v-if="!company.enroll.reports.final_report" class="list-group-item py-2 disabled">
                              Этап в данный момент недоступен
                            </li>
                            <li v-if="company.enroll.reports.final_report" class="list-group-item py-2" :class="'list-group-item-' + company.enroll.reports.final_report.status">
                              {{ company.enroll.reports.final_report.status_crm }}
                            </li>
                          </ul>
                          <div slot="footer">
                            <b-button v-if="user.roles.indexOf('ROLE_SUPER_ADMIN') > -1" class="pull-left" variant="info" size="sm" @click="revertReport(company.enroll.reports.final_report.id)"><i class="fa fa-refresh"></i></b-button>
                            <router-link tag="button" class="btn pull-right btn-success btn-sm" :disabled="!company.enroll.reports.final_report" :to="'/diagnost/' + id + '/final'">
                              <i class="fa fa-eye"></i>
                              Посмотреть отчет
                            </router-link>
                          </div>
                        </b-card>
                      </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import client from '../backend/client';
    import * as AppStorage from "../storage/appstorage";
    import { Switch as cSwitch } from '@coreui/vue'
    import Directory from "../components/Directory.vue";
    export default {
        name: "Diagnost",
        components: {
          Directory,
            AppStorage,
            cSwitch
        },
        data: () => {
            return {
                user: JSON.parse(AppStorage.get('user')),
                company: null,
                id: null,
                labelTxt: {
                    dataOn: 'да',
                    dataOff: 'нет'
                }
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            client
                .get('api/enrolls/' + this.id + '/company')
                .then((res) => {
                    this.company = res.data;
                })
            ;
        },
        methods: {
          confirmUpdate(params) {
              this.$bvModal.msgBoxConfirm('Вы уверены, что необходимо удалить этот документ?', {
                  title: 'Подтвердите действие:',
                  okVariant: 'danger',
                  okTitle: 'Да',
                  cancelTitle: 'Нет',
                  hideHeaderClose: false,
                  centered: true
              })
                  .then((res) => {
                          if(res) {
                              this.updateEnroll(params)
                          }
                  })
          },
          revertReport(id) {
              this.$bvModal.msgBoxConfirm('Вы уверены, что хотите удалить итоги прохождения этапа и перезапустить его?', {
                  title: 'Подтвердите действие:',
                  okVariant: 'info',
                  okTitle: 'Да',
                  cancelTitle: 'Нет',
                  hideHeaderClose: false,
                  centered: true
              })
              .then((result) => {
                  if(result) {
                      client
                          .post('/api/crm/enrollreports/' + id + '/reverts')
                          .then((res) => {
                              this.company.enroll = res.data;
                          })
                  }
              });
          },
          updateEnroll(params) {
              client
                  .put('api/enrolls/' + this.company.enroll.id, params)
                  .then((res) => {
                      this.company.enroll = res.data;
                  })
          }
        },
        computed: {
            isAddDoc: function() {
                return this.company ? this.company.enroll.is_add_doc : null;
            },
        },
        watch: {
            isAddDoc: {
                handler: function(newVal, oldVal) {
                    if(oldVal !== null && newVal !== oldVal) {
                        this.updateEnroll({
                            isAddDoc: newVal
                        })
                    }
                }
            }
        }
    }
</script>

<style scoped>
    ol li {
        margin-bottom: 20px;
        vertical-align: middle;
    }
  .badge-secondary {
    background: #323232;
  }
  .hidden {
    visibility: hidden;
  }
  .card-fixed-height {
    min-height: 250px;
  }
</style>
